<!--报价基本信息-->
<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title"><span class="title-icon"></span><span class="title-details">报价基本信息</span></div>
      <div slot="content">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :disabled="openLook"
          :showBtn="showBtn"/>
      </div>
      <folded-panel infoName="报价明细">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.tableDataQuote"
            :editable="true"
            :config="{ trigger: 'click', mode: 'cell' }"
            :showAdd="editTable.showAdd"
            :border="true"
            :data.sync="tableDataQuote"
            ref="delQuote"
            height=""
          >
            <template #toolbar="scope">
              <el-popover :ref="scope.row.id" placement="top" width="180">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="subDelete(scope.row.id,scope.row,'quote')">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>

                <!-- <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"/> -->
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="客户明细">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.tableDataCustomer"
            :editable="true"
            :config="{ trigger: 'click', mode: 'cell' }"
            :showAdd="editTable.showAdd"
            :border="true"
            :data.sync="tableDataCustomer"
            ref="delCustomer"
            height=""
          >
            <template #toolbar="scope">
              <el-popover :ref="scope.row.id" placement="top" width="180">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="subDelete(scope.row.id,scope.row,'customer')">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>

                <!-- <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"/> -->
              </el-popover>
            </template>
            <!--项目角色 项目角色 -->
            <template #projectRolesId="{row}">
              <span>{{row.projectRolesId?row.projectRolesId.name:''}}</span>
            </template>
            <template #projectRolesIdEdit="{row}">
              <data-box
                hostUrl="/bsProjectRoles"
                :props="{label: 'name',value: 'id'}"
                v-model="row.projectRolesId"
                :tableColumn="headLevels"
                :multiple="false"
              ></data-box>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>

      <div class="button">
        <el-button class="btn-submit" @click="submit">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import FoldedPanel from "@/components/FoldedPanel"
  import "@/components/dynamic-form"
  import '@/components/EditDataTable'
  import DataTableMixin from '@/mixins/DataTableMixin'
  import DataBox from "@/components/dynamic-form/dynamic-data-box";

  import {
    add,
    edit,
    delFormCustomer,
    delFormQuote,
    queryById
  } from '@/api/bill/price'

  export default {
    name: "NewCustomer",
    components: {
      FoldedPanel,
      DataBox
    },
    mixins: [DataTableMixin],
    data() {
      return {
        delLoading: false,
        formConfig: {
          formItemList: [
            // 关联商机	文本
            {
              type: "input",
              key: "businessId",
              label: "关联商机",
              value: "",
              // disabled: true,
              span: 8,
            },
            // 关联立项	文本
            {
              type: "input",
              key: "topicId",
              label: "关联立项",
              value: "",
              // disabled: true,
              span: 8,
            },
            // 报价客户	基础资料《客户》
            {
              label: '报价客户',
              key: 'customerId',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              url: '/customer',
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            // 销售员	基础资料《员工》
            {
              label: '销售员',
              key: 'personId',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              url: '/bs-person/getList',
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            // 总金额	数值
            {
              span: 8,
              label: '总金额',
              key: 'totals',
              type: 'input',
              // subtype: 'number',
              value: '',
              placeholder: '请输入总金额',
              rules: [
                {
                  required: true, message: '不能为空', trigger: 'blur'
                },
                {
                  pattern: "(^-?[1-9](\\d+)?(\\.\\d{1,4})?$)|(^-?0$)|(^-?\\d\\.\\d{1,4}$)",
                  message: "请输入正确的金额(保留4位小数)",
                  trigger: "blur"
                }
              ]
            },
            // 申请报价	数值
            {
              span: 8,
              label: '申请报价',
              key: 'applyPrice',
              type: 'input',
              // subtype: 'number',
              value: '',
              placeholder: '请输入申请报价',
              rules: [
                {
                  required: true, message: '不能为空', trigger: 'blur'
                },
                {
                  pattern: "(^-?[1-9](\\d+)?(\\.\\d{1,4})?$)|(^-?0$)|(^-?\\d\\.\\d{1,4}$)",
                  message: "请输入正确的金额(保留4位小数)",
                  trigger: "blur"
                }
              ]
            },
            // 报价有效期	日期
            {
              span: 8,
              label: '报价有效期',
              key: 'effectiveDate',
              type: 'date',
              placeholder: '请选择报销日期',
              rules: {
                required: true, message: '不能为空', trigger: 'blur'
              }
            },
            // 附件	按钮
            {
              type: "input",
              key: "annexId",
              label: "附件",
              value: "",
              span: 8
            },
            // 备注
            {
              span: 24,
              type: "input",
              key: "remark",
              label: "备注",
              disable: false,
              subtype: 'textarea',
              value: "",
              placeholder: "请输入备注",
            },
            // 其他明细：1对1
            // 交期说明	文本
            {
              type: "input",
              key: "deliveryExplain",
              label: "交期说明",
              value: "",
              // disabled: true,
              span: 8,
            },
            // 付款说明	文本
            {
              type: "input",
              key: "payExplain",
              label: "付款说明",
              value: "",
              // disabled: true,
              span: 8,
            },
            // 商务说明	文本
            {
              type: "input",
              key: "businessExplain",
              label: "商务说明",
              value: "",
              // disabled: true,
              span: 8,
            },
            // 备注说明	文本
            {
              type: "input",
              key: "remarkExplain",
              label: "备注说明",
              // disabled: true,
              span: 24,
              disable: false,
              subtype: 'textarea',
              value: "",
              placeholder: "请输入备注说明",
            },
          ]
        },
        showBtn: false,
        openLook: false,
        form: {},
        editTable: {
          showNumber: true,
          enableEdit: true,
          showAdd: true,
          // 报价明细
          tableDataQuote: [
            // 项目类型	基础资料《项目类型》
            {
              label: '项目类型',
              prop: 'typeId',
              editRender: {
                type: 'default',
                name: 'ElSelect',
              }
            },
            // 报价内容	文本
            {
              label: '报价内容',
              prop: 'quoteContents',
              editRender: {
                name: 'ElInput',
              }
            },
            // 报价	数值
            {
              label: '报价',
              prop: 'price',
              editRender: {name: 'ElInputNumber'}
            },
            // 数量	数值
            {
              label: '数量',
              prop: 'nums',
              editRender: {name: 'ElInputNumber'}
            },
            // 总金额	数值
            {
              label: '总金额',
              prop: 'totals',
              editRender: {name: 'ElInputNumber'}
            },
            // 备注	文本
            {
              label: '备注',
              prop: 'remark',
              editRender: {
                type: 'textarea',
                name: 'ElInput',
              }
            }

          ],
          // 客户明细
          tableDataCustomer: [
            // 客户联系人	文本
            {
              label: '客户联系人',
              prop: 'customerContact',
              editRender: {name: 'ElInput'}
            },
            // 客户电话	文本
            {
              label: '客户电话',
              prop: 'customerPhone',
              editRender: {name: 'ElInput'}
            },
            // 邮件	文本
            {
              label: '邮件',
              prop: 'email',
              editRender: {name: 'ElInput'}
            },
            // 项目角色	基础资料《项目角色》
            {
              label: '项目角色',
              prop: 'projectRolesId',
              editRender: {name: 'ElInput'}
            },
            // 对接人 checkbox
            {
              label: '对接人',
              prop: 'pickPeople',
              editRender: {
                name: 'ElSelect',
                options: [
                  {value: 1, label: '是'},
                  {value: 0, label: '否'},
                ]
              }
            },
            // 备注	文本
            {
              label: '备注',
              prop: 'remark',
              editRender: {
                name: 'ElInput',
              }
            }
          ],
        },
        isAdd: true,
        tableDataCustomer: [],
        tableDataQuote: [],
        headLevels: [
          {label: "编码", property: "code"},
          {label: "名称", property: "name", query: {type: "input"}},
          {label: "备注", property: "remark"}
        ],
      }
    },
    created() {
      const data = this.$route.query;
      this.isAdd = data.isAdd;
      if (!this.isAdd || this.isAdd === "false") {
        const id = data.id;
        queryById(id).then(res => {
          if (res.code === 200) {
            const data = res.data;
            this.form = data.bizQuote;
            this.form.customerId = {id: data.bizQuote.customerId, name: data.bizQuote.customer.name};
            this.form.personId = {id: data.bizQuote.personId, name: data.bizQuote.person.name};
            console.log(data);
            data.bizCustomerDetails.forEach(item => {
              item.projectRolesId = item.projectRoles;
            });
            this.tableDataCustomer = data.bizCustomerDetails;
            this.tableDataQuote = data.bizQuoteDetails;
            console.log(this.tableDataCustomer);
          }
        });
      }
    },
    methods: {
      submit() {
        this.form.effectiveDate = new Date(this.form.effectiveDate).getTime();
        this.form.customerId = this.form.customerId.id;
        this.form.personId = this.form.personId.id;
        this.tableDataCustomer.forEach(ele => {
          ele.projectRolesId = ele.projectRolesId.id;
        });
        if (!this.isAdd) {
          edit({
            bizQuote: this.form,
            bizCustomerDetails: this.tableDataCustomer,
            bizQuoteDetails: this.tableDataQuote,
          }).then(res => {
            this.$message.success("修改成功！")
          })
        } else {
          add({
            bizQuote: this.form,
            bizCustomerDetails: this.tableDataCustomer,
            bizQuoteDetails: this.tableDataQuote,
          }).then(res => {
            this.$message.success('保存成功！')
          })
        }
        this.$router.push('/bill/price')
      },
      cancel() {
        this.$router.push('/bill/price')
      },
      // Form删除
      subDelete(id, scope, type) {
        switch (type) {
          case 'customer':
            if (!id) {
              this.$refs.delCustomer.deleteRows(scope);
            }
            delFormCustomer(id).then(res => {
              if (res.code === 200) {
                this.$refs[id].doClose();
                this.$notify({
                  title: '删除成功',
                  type: 'success',
                  duration: 2500
                });
                this.tableDataCustomer.splice(scope.$index, 1);
              }
            });
            break;
          case 'quote':
            if (!id) {
              this.$refs.delQuote.deleteRows(scope);
            }
            delFormQuote(id).then(res => {
              if (res.code === 200) {
                this.$refs[id].doClose();
                this.$notify({
                  title: '删除成功',
                  type: 'success',
                  duration: 2500
                });
                this.tableDataQuote.splice(scope.$index, 1);
              }
            });
            break;
        }
      }
    }

  }
</script>

<style lang="scss" scoped>
  .app-container {
    .box-card {
      background-color: #fff;
      padding: 20px 30px 20px 30px;
      border-radius: 10px;

      .content-title {
        height: 40px;
        background-color: #e7eff6;
        padding-left: 20px;
        overflow: hidden;

        .title-icon {
          display: inline-block;
          margin-top: 8px;
          width: 6px;
          height: 24px;
          background-color: #1369a8;
          margin-right: 14px;
        }

        .title-details {
          overflow: hidden;
          line-height: 20px;
          display: inline-block;
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          font-family: SourceHanSansSC-regular;
        }
      }

      .button {
        padding-top: 20px;
        text-align: right;

        .btn-submit {
          width: 80px;
          height: 38px;
          background: #1369a8;
          color: white;
        }

        .btn-cancel {
          width: 80px;
          height: 38px;
          background: #fff;
        }
      }
    }
  }
</style>
